<template>
    <b-modal @ok='validate' @hidden='errors=[]' centered ref="setWaitModal" :title="autobrand('translations.await_reply_from_patient')" size="md">
        <div class='d-block'>
            <p v-if='waitmessage' class="alert alert-warning">{{ $t(waitmessage) }}</p>
            <b-form-row>
                <b-col cols="9"><label class="col-form-label">{{$t('translations.set_waiting')}}</label></b-col>
                <b-col cols="15">
                    <!-- <b-form-input v-model="waiting_until" type="number" min='1' max='9'></b-form-input> -->
                    <datetime2 v-model="waiting_until"></datetime2>
                </b-col>
            </b-form-row>
            <inline-error v-bind:errors='errors' type='waiting_until'></inline-error>
            <b-form-row>
                <b-col cols="9"><label class="col-form-label">{{autobrand('translations.inform_patient_that_request_is_waiting')}}</label></b-col>
                <b-col cols="15"><input type='checkbox' class="mt-3 input" v-model="wait_send_message_to_patient"></b-col>
            </b-form-row>
            <inline-error v-bind:errors='errors' type='wait_send_message_to_patient'></inline-error>

            <hr>

            <div class="form-row">
                <div class="col-9">
                    <label>{{$t('translations.if_no_reply_return_to')}}:</label>
                </div>
                <div class="col-15">
                    <div v-if='showcompleteoption && (thread && thread.thread_provider_xref && thread.thread_provider_xref.length == 1)' class="form-check">
                        <input v-model='post_wait_complete' id='pws_completed' class="form-check-input" type="radio" name="post_wait_complete" value="1">
                        <label class="form-check-label" for="pws_completed">
                        {{$t('translations.completed')}}
                        </label>
                    </div>
                    <div class="form-check">
                        <input v-model='post_wait_complete' id='pws_assigned' class="form-check-input" type="radio" name="post_wait_complete" value="0">
                        <label class="form-check-label" for="pws_assigned">
                        {{$t('translations.current_assignee')}}
                        </label>
                    </div>
                </div>
            </div>

        </div>
        <div slot="modal-footer" class="w-100">
            <div class='d-flex justify-content-end'>
                <b-btn size="sm" class="m-1" variant="primary" v-on:click.prevent='$refs.setWaitModal.hide();'>
                    {{ $t('translations.cancel') }}
                </b-btn>
                <b-btn v-if='showskip' size="sm" class="m-1" variant="primary" v-on:click.prevent='skip();'>
                    {{ $t('translations.skip') }}
                </b-btn>
                <b-btn size="sm" class="m-1" variant="primary" v-on:click.prevent='validate();'>
                    {{ $t('translations.okay') }}
                </b-btn>
                
                
            </div>
        </div>
    </b-modal>

</template>


<script>

	export default {
        props: {
            thread: {},
            waitmessage: {
                default: null,
            },
            showskip: {
                default: false,
            },
            validateonly: {
                default: false,
            },
            showcompleteoption: {
                default: true,
            }
		},
		data: function(){
            var time = this.moment(this.$root.provider.wait_exit_time, "HH:mm");
			return {
                waiting_until: this.moment().add(this.$root.provider.wait_default_days, "days")
                    .set({hour: time.get('hour'), minute: time.get('minute'), second: 0})
                    .format("YYYY-MM-DD HH:mm"),
                post_wait_complete: 0,
                wait_send_message_to_patient: 0,
                errors: [],
                local_presend: null,
			};
		},
		computed: {
            
		},
		watch: {

		},
		created() {
        },
		beforeDestroy() {
		},
		mounted() {
            
		},

		methods: {
            
			show() {
                var time = this.moment(this.$root.provider.wait_exit_time, "HH:mm");
                this.waiting_until = this.moment().add(this.$root.provider.wait_default_days, "days")
                    .set({hour: time.get('hour'), minute: time.get('minute'), second: 0})
                    .format("YYYY-MM-DD HH:mm");
                this.post_wait_complete = 0; //(this.thread.thread_provider_xref && this.thread.thread_provider_xref.length == 1) ? 1 : 0;
                this.wait_send_message_to_patient = 0;
                this.$refs.setWaitModal.show();
            },
            skip() {
                this.$refs.setWaitModal.hide();
                this.$emit("skip-wait");
            },
            fake_presend() {
                return Promise.resolve();
            },
            validate(event) {
                
                this.errors = [];

                var date = this.moment(this.waiting_until);

                if(!date.isValid()) {
                    //this.waiting_until = this.$root.provider.wait_default_days;
                    this.injectFieldErrors("waiting_until", ["Please enter a valid date"]);
					event.preventDefault();
					return false;
				}
                if(date <= this.moment()) {
                    this.injectFieldErrors("waiting_until", ["Date must be in the future"]);
					event.preventDefault();
					return false;
                }

				this.$refs.setWaitModal.hide();
                if(this.validateonly) {
                    this.$emit("validated-wait");
                    return true;
                }
                this.set();
            },
            set() {
                var date = this.moment(this.waiting_until).format("YYYY-MM-DD H:m");
                
                //date = this.moment().add(this.waiting_until, this.wait_time_measure).format("YYYY-MM-DD " + (this.wait_time_measure == "minutes" ? " H:m" : " " + this.$root.provider.wait_exit_time));
				
                //console.log("Processing wait");
                this.setLoading(true);
                return axios.put(this.$root.apiBase + '/threads/setWait/' + this.thread.id, {
                        "waiting_until": date,
                        "post_wait_complete": this.post_wait_complete,
                        "wait_send_message_to_patient": this.wait_send_message_to_patient
                }).then((res) => {
                    this.thread.thread_provider.waiting_until = date;
                    this.setLoading(false);
                    this.$emit("set-wait");
                    this.addNotification({type: "success", content: this.$t('translations.set_thread_waiting')});
                    return true;
                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "set wait");
                });
			},

		}
    }
</script>
